import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {Icon} from 'antd';

interface LabelIconProps extends WithTranslation {
}
class LabelIcon extends React.Component<LabelIconProps>{
    public render() {
        const { children, t } = this.props;
        return (
            <span>
                {children}
                <Icon type="info-circle" style={{ fontSize: '12px', color: 'grey', marginLeft: 3, marginRight:3 }} />
            </span>
        )
    }
}

export default (withTranslation()(LabelIcon) as any)